module.exports = __webpack_public_path__ + "img/main1.8ea635de.jpg";